import { Menu } from '@mui/material';
import { styled } from '@mui/material/styles';

export const MenuWrapper = styled(Menu)({
  '& .MuiMenu-paper': {
    minWidth: 220,
    maxWidth: 400,
  },
});
